import Swiper from 'swiper';
import { Navigation, EffectFade, Thumbs, Scrollbar } from 'swiper/modules';

export default () => {
  const swipers = document.querySelectorAll('.swiper__carousel')
  console.log("swipers",swipers)
  const carouselFn = (el, cconfig) => {
    const { config } = el.dataset
    const _config = cconfig || window[config]
    if(!_config) return console.log('Please set data-config!');
    _config.modules = [Navigation,EffectFade,Thumbs,Scrollbar]
    var swiper = new Swiper(el, _config)
    _config.$swiper = swiper;
    loadImages(el)

    function loadImages(el) {
      const images = el.querySelectorAll('.image, .image-svg__elem')
      images.forEach(el => {
        const	lazyImages = window.lazyImages = window.lazyImages || []
        //if(el && window.lazyImageFn) window.lazyImageFn(el);
        //else if(el) lazyImages.push(el)
        if(el) lazyImages.push(el)
      })
    }
  }

  swipers.forEach(el => carouselFn(el))
}